import { useThemeContext } from "../../../context/ThemeContext";

import { Card } from "../Card";
import { CardLabel } from "../CardLabel";
import { Button } from "../../Button/Button";

import styles from "./ListCard.module.scss";

import { ListCardProps } from "../types";

interface ListItemProps {
  items: string[];
}

function ListItem({ items }: ListItemProps) {
  const theme = useThemeContext();

  return (
    <ul className={styles.nowList}>
      {items.map((item, i) => (
        <li key={i} className={styles.nowItem}>
          <span style={{ color: theme.acc }}>→</span>
          <span style={{ color: theme.fg, opacity: 0.88 }}>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export function ListCard({
  label,
  labelType,
  title,
  items = [],
  hasButton,
  buttonType,
  buttonText,
  buttonOnClick,
}: ListCardProps) {
  const theme = useThemeContext();

  return (
    <Card theme={theme}>
      <CardLabel cardLabelType={labelType} cardLabelText={label} />
      <h3 className={styles.nowTitle} style={{ color: theme.fg }}>
        {title}
      </h3>
      <ListItem items={items} />
      <div
        className={styles.nowFooter}
        style={{ borderTopColor: theme.rule, color: theme.muted }}
      >
        <span>last updated · June 2026</span>
        {hasButton && (
          <Button
            buttonType={buttonType}
            buttonText={buttonText}
            onClick={() => buttonOnClick?.()}
          />
        )}
      </div>
    </Card>
  );
}
